module.exports = __webpack_public_path__ + "static/04-2-aa3ae389eea940e6b053e26f851536dd.jpg";